import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'PRODUCTION_UPDATE',
    smsDelete : 'PRODUCTION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        production: [],
        production_details: {},

        submitSuccess: false,
        productionLoading: false,
        productionError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_PRODUCTION(state, results) {
            state.production = results;
        },

        GET_PRODUCTION_DETAILS (state, items) {
            state.production_details = items
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        PRODUCTION_LOADING (state, loading) {
            state.productionLoading = loading;
        },

        PRODUCTION_ERROR (state, hasError) {
            state.productionError = hasError;
        }
    },

    actions: {
        async addCoProduction ({commit, dispatch}, payload) {
            commit('PRODUCTION_LOADING', true);
            commit('PRODUCTION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_production, payload.production, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoProduction')
                return response

            } catch (e) {
                commit('PRODUCTION_ERROR', true);
            } finally {
                commit('PRODUCTION_LOADING', false);
            }
        },

        async fetchCoProduction ({ commit }) {
            commit('PRODUCTION_LOADING', true);
            commit('PRODUCTION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.production_list, config);
                let response = result.data.data
                commit('SET_PRODUCTION', response);
                return result
            } catch(error) {
                commit('PRODUCTION_ERROR', true);
            } finally {
                commit('PRODUCTION_LOADING', false);
            }
        },

        async getDetails ({ commit }, payload) { 
            let response = await axios.get(V1API.get_production_details + payload).then(result => {
                let items = result.data.data
                commit('GET_PRODUCTION_DETAILS', items)
                return result
            })
            return response
        },

        async updateCoProduction ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_production + payload.id, payload.production, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchCoProduction')
                return response

            } catch (e) {
                commit('PRODUCTION_ERROR', true);
            } finally {
                commit('PRODUCTION_LOADING', false);
            }
        },

        async deleteCoProduction({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_production + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchCoProduction')
            return response
        }
    },

    getters: {}
}
